import React, { useEffect, useRef, useState } from "react";
import { Text } from "components";
import { useNavigate } from "react-router-dom";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Select from "react-select";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-toastify/dist/ReactToastify.css";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, Legend, Pie, PieChart, } from "recharts";
import AccessRightCard from "pages/AccessRight/AccessRightCard";
import { MdOutlinePendingActions } from "react-icons/md";
import PieChartSkeleton from "components/PageSkeleton/PieChartSkeleton";
import CustomTooltip from "components/Graphs/CustomTooltip";
import { FaSuitcaseMedical } from "react-icons/fa6";
import { RiErrorWarningFill, RiPassPendingLine } from "react-icons/ri";
import { FcDataRecovery } from "react-icons/fc";
import { IoMdPeople } from "react-icons/io";
import CustomLegend from "components/Graphs/CustomLegend";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;

const OutstandingOpdReports = () => {
    const gridRef = useRef();
    const navigate = useNavigate();
    const [doclist, setdoclist] = useState([]);
    const [Doctors, setDoctors] = useState([]);
    const [paymentType, setpaymentType] = useState([]);
    const [paymentTypeId, setPaymentTypeId] = useState(0);
    const [user, setuser] = useState({});
    const [consultant, setConsultant] = useState(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modewiseData, setmodewiseData] = useState([]);
    const [itemwiseTotalOpdCollection, setItemwiseTotalOpdCollection] = useState([]);
    // const [dataforbargraph, setDataforbargraph] = useState([]);
    const today = new Date();
    const todayFormatted = today.toISOString().split("T")[0];
    const [userList, setuserlist] = useState([]);
    const [pendingPaymenttList, setPendingPaymenttList] = useState([])
    const [totalOpdBills, setTotalOpdBills] = useState(0);
    const [outstandingBills, setOutstandingBills] = useState(0);

    // start date and end date 
    const firstDayOfMonth = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        2
    ).toISOString().split("T")[0];

    const [startdate, setStartdate] = useState(firstDayOfMonth);

    const [enddate, setEnddate] = useState(
        new Date().toISOString().split("T")[0],
    );

    const now = new Date();
    //  for date formatting
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        return date.toLocaleDateString("en-GB", options).replace(",", "");
    };
    // for time formatting
    const formatTime = (date) => {
        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";
        return `${hours}:${minutes} ${ampm}`;
    };
    const token = sessionStorage.getItem("token");
    const headers = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    // Api for user detail
    const getuser = () => {
        axios
            .post("/api/doctor/userdetail/get", {}, headers)
            .then((response) => {
                setuser(response?.data[0]);
                // console.log(response.data);
            })
            .catch(() => {
                console.log("Error");
            });
    };
    useEffect(() => {
        getuser();
    }, []);

    // api for all consultants

    const getAppointmentDoctor = () => {
        axios
            .post("/api/doctor/userdetail/getAll", {}, headers)
            .then((response) => {
                const filteredDoctors = response.data.filter(
                    (doctor) => doctor.user_type_id === 2 && doctor.isactive === true,
                );
                setDoctors(filteredDoctors);
            })
            .catch((error) => {
                console.log("Error");
            });
    };
    const getpaymentType = () => {
        axios
            .post("/api/doctor/payment-type/get", {}, headers)
            .then((response) => {
                const filteredDoctors = response.data;
                setpaymentType(filteredDoctors);
            })
            .catch((error) => {
                console.log("Error");
            });
    };
    useEffect(() => {

        getAppointmentDoctor();
        getpaymentType()
    }, [])

    useEffect(() => {
        // Retrieving data from sessionStorage
        const storeddoclist = sessionStorage.getItem("docAccesslist");

        if (storeddoclist) {
            try {
                // Parsing the JSON string to an array of objects
                const parseddoclist = JSON.parse(storeddoclist);
                setdoclist(parseddoclist);
            } catch (error) {
                console.error("Error parsing JSON:", error);
            }
        }
    }, []);

    const getData = () => {
        console.log("get data function call");
        setLoading(true)
        axios
            .post(
                "/api/doctor/my_report/getOpdReport",
                {
                    startDate: startdate,
                    endDate: enddate,
                    consultantId: consultant > 0 ? consultant : null,
                    paymentTypeId: paymentTypeId > 0 ? paymentTypeId : null,
                },
                headers,
            )
            .then((response) => {
                setData(response?.data.myReport || []);
                // setmodewiseData(response?.data.paymentTypeSummary || []);

                setLoading(false);
                console.log("modewisedata");
                // console.log(response.data);
                console.log(modewiseData);
            })
            .catch(() => {
                console.log("Error");
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };
    //   to load data 
    useEffect(() => {
        getData();
    }, [startdate, enddate, consultant, paymentTypeId]);

    const filteredData = data.filter(
        (item) => parseFloat(item.pending_amount) !== 0
    );
    console.log(filteredData);
    const gridHeight = Math.max(filteredData.length * 45 + 60, 150);
    const latestRecords = Object.values(
        data.reduce((acc, item) => {
            const id = item.id;

            const currDateTime = new Date(`${item.payment_date} ${item.payment_time}`);

            if (!acc[id]) {
                acc[id] = item;
            } else {
                const prevDateTime = new Date(
                    `${acc[id].payment_date} ${acc[id].payment_time}`
                );

                if (currDateTime > prevDateTime) {
                    acc[id] = item;
                }
            }

            return acc;
        }, {})
    );

    //  sum of latest pending_amount
    const totalOutstanding = latestRecords.reduce((sum, item) => {
        return sum + parseFloat(item.pending_amount || 0);
    }, 0);

    const dataforbargraph = [
        {
            name: "OPD Consultation",
            total_fee: totalOutstanding
        }
    ];
    const todayStr = new Date().toISOString().split("T")[0];

    const todaysRecovery = data
        .filter(item => item.payment_date === todayStr)
        .reduce((sum, item) => {
            return sum + parseFloat(item.paid_amount || 0);
        }, 0);

    const generateOutstandingExcel = async () => {
        if (filteredData.length === 0) {
            toast.error("No outstanding data to export");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Outstanding OPD Report");

        const addStyledRow = (label, value) => {
            const row = worksheet.addRow([label, value]);
            row.getCell(1).font = { bold: true };
        };

        // Header
        addStyledRow("Report Name:", "Outstanding OPD Report");
        addStyledRow(
            "Date Range:",
            `${formatDate(startdate)} to ${formatDate(enddate)}`
        );
        addStyledRow(
            "Consultant:",
            consultant !== 0 ? filteredData[0]?.user_name : "All"
        );
        addStyledRow("Generated By:", user?.name);
        addStyledRow(
            "Generated On:",
            `${formatDate(now)} ${formatTime(now)}`
        );

        worksheet.addRow([]);

        // Table Headers
        const headers = [
            "Sr No.",
            "Patient Name",
            "OPD Date",
            "OPD Time",
            "Consultant",
            "Total Bill",
            "Paid",
            "Pending",
            "Payment Mode",
            "Transaction ID",
            "Received By",
            "Payment Date",
            "Payment Time",
        ];

        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };

        // Data Rows
        filteredData.forEach((row, index) => {
            const newRow = worksheet.addRow([
                index + 1,
                row.patient_name,
                row.slot_date,
                row.slot_start_time,
                row.user_name,
                parseFloat(row.total_bill_amount || 0),
                parseFloat(row.paid_amount || 0),
                parseFloat(row.pending_amount || 0),
                row.payment_type,
                row.transactionid,
                row.received_by,
                row.payment_date,
                row.payment_time,
            ]);

            newRow.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                };
            });
        });

        // Total row
        worksheet.addRow([]);
        worksheet.addRow([
            "",
            "",
            "",
            "",
            "TOTAL OUTSTANDING",
            "",
            "",
            totalOutstanding,
        ]);

        // Save file
        const buffer = await workbook.xlsx.writeBuffer();
        const fileName = `Outstanding_OPD_Report_${formatDate(startdate)}_to_${formatDate(enddate)}.xlsx`;

        saveAs(
            new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }),
            fileName
        );
    };
    // AgGrid
    // coldata
    const columnDefs = [
        { headerName: "Sr No", valueGetter: "node.rowIndex + 1", width: 80, minWidth: 80 },
        {
            headerName: "Patient Name",
            field: "patient_name",
            width: 180,
            minWidth: 170,
        },
        {
            headerName: "OPD Date",
            field: "slot_date",
            width: 120,
            minWidth: 110,
            valueGetter: (params) => {
                return `${params.data.slot_date || ""}`;
            },
        },
        {
            headerName: "OPD Time",
            field: "slot_date",
            width: 100,
            minWidth: 90,
            valueGetter: (params) => {
                return `${params.data.slot_start_time || ""}`;
            },
        },
        { headerName: "Consultant", field: "user_name", width: 150, minWidth: 140 },
        {
            headerName: "OPD Status",
            field: "appointment_status",
            width: 150,
            minWidth: 140,
        },
        {
            headerName: "Total Bill Amount",
            field: "total_bill_amount",
            width: 150,
            minWidth: 140,
            type: "numericColumn",
        },
        {
            headerName: "Amount Paid",
            field: "paid_amount",
            width: 150,
            minWidth: 140,
            type: "numericColumn",
        },
        {
            headerName: "Payment Mode",
            field: "payment_type",
            width: 150,
            minWidth: 140,
        },
        {
            headerName: "Transaction ID/Cheque No",
            field: "transactionid",
            width: 200,
            minWidth: 190,
        },
        {
            headerName: "Pending Amount",
            field: "pending_amount",
            width: 150,
            minWidth: 140,
            type: "numericColumn",
        },
        {
            headerName: "Received By",
            field: "received_by",
            width: 130,
            minWidth: 120,
        },
        {
            headerName: "Payment Date",
            field: "payment_date",
            width: 130,
            minWidth: 120,
        },
        {
            headerName: "Payment Time",
            field: "payment_time",
            width: 130,
            minWidth: 120,
            maxWidth: 140,
            pinned: "right",
        },
    ];

    // piechart
    const COLORS = [
        "url(#cashGrad)",
        "url(#upiGrad)",
        "url(#cardGrad)",
        "url(#insuranceGrad)",
        "url(#mobileGrad)",
        "url(#chequeGrad)",
        "url(#neftGrad)"
    ];
    const getAgingData = () => {
        const today = new Date();

        const buckets = {
            "0-7 Days": 0,
            "7-30 Days": 0,
            "30-60 Days": 0,
            "60+ Days": 0,
        };

        latestRecords.forEach((item) => {
            const pending = parseFloat(item.pending_amount || 0);

            if (pending <= 0) return;

            const billDate = new Date(item.payment_date);
            const diffTime = today - billDate;
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays <= 7) {
                buckets["0-7 Days"] += pending;
            } else if (diffDays <= 30) {
                buckets["7-30 Days"] += pending;
            } else if (diffDays <= 60) {
                buckets["30-60 Days"] += pending;
            } else {
                buckets["60+ Days"] += pending;
            }
        });

        return Object.keys(buckets).map((key) => ({
            name: key,
            value: buckets[key],
        }));
    };
    // for piechart
    const agingData = getAgingData().filter(item => item.value > 0);
    const total = agingData.reduce((sum, item) => sum + item.value, 0);
    const showActionColumn = doclist.some(
        (item) => item.hospital_module_id == 33 && item.view,
    );
    return (
        <>
            {showActionColumn ? (
                <div className="w-full flex flex-col gap-1 bg-[#f4f6ff]">
                    <ToastContainer />
                    {/* filter section */}
                    <div className="filter-section ">
                        {/* start date */}
                        <div>
                            <label className="filter-section-label">Start Date</label>
                            <input
                                type="date"
                                value={startdate}
                                onChange={(e) => setStartdate(e.target.value)}
                                className="filter-section-input"
                                max={todayFormatted}
                            />
                        </div>
                        {/* End date */}
                        <div >
                            <label className="filter-section-label">End Date</label>
                            <input
                                type="date"
                                value={enddate}
                                onChange={(e) => setEnddate(e.target.value)}
                                className="filter-section-input"
                                max={todayFormatted}
                            />
                        </div>
                        {/* payment mode */}
                        <div>
                            <label className="filter-section-label">Select Payment Mode</label>
                            <Select
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                options={[
                                    { label: "All", value: 0 },
                                    ...paymentType.map((pt) => ({
                                        label: pt.name,
                                        value: pt.id,
                                    })),
                                ]}
                                onChange={(selected) => setPaymentTypeId(selected.value)}
                                classNamePrefix="filter-custom-select"
                                placeholder="All"
                            />
                        </div>

                        {/* Consultant */}
                        <div>
                            <label className="filter-section-label">Select Consultant</label>
                            <Select
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                options={[
                                    { label: "All", value: 0 },
                                    ...Doctors.map((doc) => ({
                                        label: "Dr. " + doc.name,
                                        value: doc.id,
                                    })),
                                ]}
                                onChange={(selected) => setConsultant(selected.value)}
                                placeholder="All"
                                classNamePrefix="filter-custom-select"
                            />
                        </div>

                        {/* Buttons */}
                        <div className="">
                            <button
                                onClick={() => {
                                    if (enddate < startdate) {
                                        toast.error("End date cannot be before Start date");
                                        return;
                                    }
                                }}
                                className="btn-primary mt-4 hidden"
                            >
                                Generate Report
                            </button>
                        </div>
                        <div>
                            <button
                                onClick={() => {
                                    if (enddate < startdate) {
                                        toast.error("End date cannot be before Start date");
                                        return;
                                    }
                                    else {
                                        generateOutstandingExcel()
                                    }
                                }}
                                className="btn-secondary mt-5"
                            >
                                Export Excel
                            </button>
                        </div>
                    </div>
                    <hr className="border" />

                    {/* main body*/}
                    <div className=" flex flex-col gap-1 w-full bg-[#f4f6ff]">
                        {/* Cards section */}
                        <div className="flex  items-center  justify-between  my-1 gap-10 mx-14">

                            <div className="custom-box p-4 rounded-xl flex items-center w-full gap-3">

                                {/* Icon */}
                                <FaSuitcaseMedical className="text-[var(--primary-color)] text-2xl" />

                                <div>
                                    <p className="text-gray-500 text-sm">Total OPD Bills</p>

                                    {/* Amount */}
                                    <div className="flex items-center gap-1">
                                        <IoMdPeople className="text-xl" />
                                        <span className="text-xl font-bold  "> {data.length}</span>
                                    </div>
                                </div>

                            </div>
                            <div className="custom-box p-4 rounded-xl  flex items-center w-full gap-3">
                                <MdOutlinePendingActions className="text-red-500 text-2xl" />
                                <div>
                                    <p className="text-gray-500 text-sm">Outstanding Bills</p>
                                    <div className="flex items-center gap-1">
                                        <IoMdPeople className="text-xl" />
                                        <span className="text-xl font-bold  ">{filteredData.length}</span>
                                    </div>
                                </div>
                            </div>

                            <div className=" custom-box p-4 rounded-xl  flex items-center w-full gap-3">
                                <RiPassPendingLine className="text-green-800 text-2xl" />
                                <div>
                                    <p className="text-gray-500 text-sm">Total Outstanding</p>
                                    <h2 className="text-xl font-bold text-green-900">₹ {totalOutstanding}</h2>
                                </div>
                            </div>
                            <div className="custom-box p-4 rounded-xl    items-center gap-3 hidden">
                                <FcDataRecovery className="text-orange-500 text-2xl" />
                                <div>
                                    <p className="text-gray-500 text-sm">Today's Recovery</p>
                                    <h2 className="text-xl font-bold text-orange-600">₹ {todaysRecovery}</h2>
                                </div>
                            </div>

                        </div>
                        {/* table and graph */}
                        <div className="flex flex-row">
                            {/* left section */}
                            <div className=" w-[60%] ">
                                {/* alert */}
                                <div className="flex items-center gap-2 my-2 bg-orange-50 border border-orange-200 px-3 py-1 rounded-md">
                                    <RiErrorWarningFill className="text-orange-500" />
                                    <p className="text-sm text-orange-800 whitespace-nowrap">
                                        This table shows <b>all bills with pending amounts</b>. Use it for follow-ups & payment recovery.
                                    </p>
                                </div>
                                {/* aggrid */}
                                <div className="custom-box p-3 mb-5">
                                    <Text className="font-semibold mb-2 text-sm">Outstanding bills List</Text>
                                    <div className="flex items-center gap-2">
                                        <RiErrorWarningFill className="text-[var(--primary-color)]" />
                                        <p className="text-xs   whitespace-nowrap">
                                            Showing all pending OPD bills. Each row shows payment details & outstanding amount
                                        </p>
                                    </div>
                                    <div>

                                        <Text></Text>
                                    </div>
                                    <div className=" p-3 ag-theme-alpine  w-full  "
                                        style={{ height: gridHeight }}>
                                        {
                                            loading ? (<div className="space-y-2 animate-pulse {{ height: gridHeight }}">
                                                {[...Array(4)].map((_, i) => (
                                                    <div key={i} className="flex justify-between items-center space-x-3 mt-5 ">

                                                        {/* left label */}
                                                        <div className="h-7 w-[60%] bg-gray-300 rounded"></div>

                                                        {/* Total amount */}
                                                        <div className="h-7 w-[40%] bg-gray-300 rounded"></div>
                                                        {/* left label */}
                                                        <div className="h-7 w-[60%] bg-gray-300 rounded"></div>


                                                    </div>
                                                ))}
                                            </div>) : (
                                                <AgGridReact
                                                    ref={gridRef}
                                                    columnDefs={columnDefs}
                                                    rowData={filteredData}
                                                />
                                            )
                                        }

                                    </div>
                                </div>
                            </div>
                            {/* right section */}
                            <div className="flex flex-col w-full m-2 ">
                                {/* bar graph  */}
                                {
                                    loading ?
                                        (<div className="flex flex-col my-3 w-[100%] custom-box p-2">
                                            <div className="space-y-2 ml-10 animate-pulse {{ height: gridHeight }}">
                                                {[...Array(4)].map((_, i) => (
                                                    <div key={i} className="flex justify-between items-center space-x-3 mt-5 ">

                                                        {/* left label */}
                                                        <div className="h-7 w-[90%] bg-gray-300 rounded"></div>

                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        ) : (
                                            <div className="flex flex-col my-3 w-[90%] h-[150px] custom-box p-2">
                                                <div className="flex items-center justify-start">
                                                    <Text className=" text-[16px] font-bold ">
                                                        Outstanding by Department
                                                    </Text>
                                                </div>
                                                <hr className="border border-gray-300 mt-3 mx-3" />
                                                <ResponsiveContainer width="100%" height="70%">
                                                    <BarChart
                                                        data={dataforbargraph}
                                                        layout="vertical"
                                                        barSize={15}
                                                    >
                                                        <defs>
                                                            <linearGradient id="upiGrad" x1="0" y1="0" x2="1" y2="1">
                                                                <stop offset="0%" stopColor="#42A5F5" />
                                                                <stop offset="100%" stopColor="#1565C0" />
                                                            </linearGradient>
                                                        </defs>
                                                        <XAxis type="number" hide />
                                                        <YAxis
                                                            type="category"
                                                            dataKey="name"
                                                            width={120}
                                                        />

                                                        <Tooltip content={<CustomTooltip />} />

                                                        <Bar dataKey="total_fee" stackId="a" fill="url(#upiGrad)" />
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            </div>
                                        )
                                }
                                {/* piechart */}
                                {loading ? (<PieChartSkeleton />) :
                                    (
                                        <div className="custom-box h-[250px] p-3">
                                            <Text className="mb-2">Aging Analysis</Text>

                                            {agingData.length === 0 ? (
                                                <p className="text-sm text-gray-500 text-center mt-10">
                                                    No outstanding data
                                                </p>
                                            ) : (
                                                <ResponsiveContainer width="100%" height="100%">
                                                    <PieChart>
                                                        <defs>
                                                            <linearGradient id="cashGrad" x1="0" y1="0" x2="1" y2="1">
                                                                <stop offset="0%" stopColor="#66BB6A" />
                                                                <stop offset="100%" stopColor="#2E7D32" />
                                                            </linearGradient>

                                                            <linearGradient id="upiGrad" x1="0" y1="0" x2="1" y2="1">
                                                                <stop offset="0%" stopColor="#42A5F5" />
                                                                <stop offset="100%" stopColor="#1565C0" />
                                                            </linearGradient>

                                                            <linearGradient id="cardGrad" x1="0" y1="0" x2="1" y2="1">
                                                                <stop offset="0%" stopColor="#4FC3F7" />
                                                                <stop offset="100%" stopColor="#0288D1" />
                                                            </linearGradient>

                                                            <linearGradient id="insuranceGrad" x1="0" y1="0" x2="1" y2="1">
                                                                <stop offset="0%" stopColor="#FFA726" />
                                                                <stop offset="100%" stopColor="#EF6C00" />
                                                            </linearGradient>

                                                            <linearGradient id="mobileGrad" x1="0" y1="0" x2="1" y2="1">
                                                                <stop offset="0%" stopColor="#BA68C8" />
                                                                <stop offset="100%" stopColor="#6A1B9A" />
                                                            </linearGradient>

                                                            <linearGradient id="chequeGrad" x1="0" y1="0" x2="1" y2="1">
                                                                <stop offset="0%" stopColor="#EF5350" />
                                                                <stop offset="100%" stopColor="#B71C1C" />
                                                            </linearGradient>

                                                            <linearGradient id="neftGrad" x1="0" y1="0" x2="1" y2="1">
                                                                <stop offset="0%" stopColor="#4DD0E1" />
                                                                <stop offset="100%" stopColor="#006064" />
                                                            </linearGradient>
                                                        </defs>
                                                        <Pie
                                                            data={agingData}
                                                            dataKey="value"
                                                            nameKey="name"
                                                            cx="50%"
                                                            cy="50%"
                                                            outerRadius={60}
                                                            label={({ percent, x, y }) => (
                                                                <text
                                                                    x={x}
                                                                    y={y}
                                                                    fill="black"
                                                                    fontSize="12"
                                                                    fontWeight="bold"
                                                                    textAnchor="middle"
                                                                    dominantBaseline="central"
                                                                >
                                                                    {(percent * 100).toFixed(1)}%
                                                                </text>
                                                            )}
                                                            labelLine={false}
                                                        >
                                                            {agingData.map((entry, index) => (
                                                                <Cell key={index} fill={COLORS[index % COLORS.length]} />
                                                            ))}
                                                        </Pie>
                                                        <Tooltip content={<CustomTooltip />} />
                                                        <Legend
                                                            content={<CustomLegend COLORS={COLORS} total={total} />}
                                                            layout="vertical"
                                                            align="right"
                                                            verticalAlign="middle"
                                                        />
                                                    </PieChart>
                                                </ResponsiveContainer>
                                            )}
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                </div >

            ) : (
                <AccessRightCard />
            )}
        </>
    );
};

export default OutstandingOpdReports;